import { gql } from '@apollo/client';

export const GET_PATHFIX_INTEGRATION_PARAMS = gql`
  query GetPathfixIntegrationParams{
    pathfixOauthIntegrationParams{
      publicKey
    }
  }
`;
